import { gql } from '@apollo/client';

export const CREATE_LESSONS_MUTATION = gql`
  mutation CreateLessons($objects: [lessons_insert_input!]!) {
    insert_lessons(objects: $objects) {
      affected_rows
    }
  }
`;
